import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceSubheadline = ({ blok }) => (

    <div className="servicesubheadline-wrap wrap" {...storyblokEditable(blok)}>
        <div className="inner-wrap servicesubheadline-innerwrap" >
      <h2 className="text-2xl">{blok.subheadline}</h2>
    </div>
  </div>
);

export default ServiceSubheadline;
